import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import swal from "sweetalert";
import { fetchDuplicateTargets, duplicateSuggestion } from "./duplicateApi";

const PRIMARY = "#429853";

const DuplicateModal = ({ show, onHide, productId, suggestion }) => {
  const [targets, setTargets] = useState([]);
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (show && productId) {
      setSelected([]);
      setLoading(true);
      fetchDuplicateTargets(productId)
        .then((t) => {
          setTargets(t);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
          swal("Erreur", "Impossible de charger les établissements.", "error");
        });
    }
  }, [show, productId]);

  const toggle = (id) =>
    setSelected((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));

  const handleDuplicate = () => {
    if (selected.length === 0) {
      swal("Aucun établissement", "Sélectionnez au moins un établissement cible.", "warning");
      return;
    }
    setSubmitting(true);
    duplicateSuggestion(suggestion.id, selected)
      .then((report) => {
        setSubmitting(false);
        const created = report.filter((r) => r.status === "created");
        const skipped = report.filter((r) => r.status === "skipped");
        const lines = report
          .map((r) =>
            r.status === "created"
              ? `• ${r.establishmentName} : dupliquée ✅`
              : `• ${r.establishmentName} : ignorée — ${r.reason}`
          )
          .join("\n");
        swal(
          `Duplication : ${created.length} créée(s), ${skipped.length} ignorée(s)`,
          lines || "Aucun établissement traité.",
          created.length ? "success" : "info"
        );
        onHide();
      })
      .catch(() => {
        setSubmitting(false);
        swal("Erreur", "La duplication a échoué.", "error");
      });
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Dupliquer « {suggestion && suggestion.name} »</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Vers quels établissements dupliquer cette suggestion ?</p>
        {loading ? (
          <p>Chargement…</p>
        ) : targets.length === 0 ? (
          <p>Aucun autre établissement disponible.</p>
        ) : (
          targets.map((t) => (
            <Form.Check
              key={t.id}
              type="checkbox"
              id={`dup-est-${t.id}`}
              label={t.hasProduct ? t.name : `${t.name} — produit absent`}
              disabled={!t.hasProduct}
              checked={selected.includes(t.id)}
              onChange={() => toggle(t.id)}
            />
          ))
        )}
        <p style={{ fontSize: 12, color: "#6b6b68", marginTop: 12 }}>
          Une suggestion du même nom déjà présente sur un établissement sera ignorée.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onHide}>
          Annuler
        </Button>
        <Button
          style={{ backgroundColor: PRIMARY, borderColor: PRIMARY }}
          onClick={handleDuplicate}
          disabled={submitting || loading}
        >
          {submitting ? "Duplication…" : "Dupliquer"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DuplicateModal;
